<template>
  <div class="progress-bar-container">
    <div class="progress-bar-background" :style="fillBackground">
      <div class="progress-bar-fill" :style="fillStyle"></div>
      <span class="progress-bar-text">
        Progresso de preenchimento {{ percentage }}%
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  props: {
    step: {
      type: Number,
      required: true,
      default: 1
    },
    totalSteps: {
      type: Number,
      required: true,
      default: 6
    },
  },
  computed: {
    percentage() {
      if (this.totalSteps <= 1) return 100;
      return Math.round(Math.min(((this.step - 1) / (this.totalSteps - 1)) * 100, 100));
    },
    fillStyle() {
      return {
        width: this.percentage + '%',
        background: 'linear-gradient(90deg, #ee411c 0%,#f45928 64%,#f46b30 100%)',
        transition: 'width 0.3s, background 0.3s'
      };
    },
    fillBackground(){ if (this.step > 1) return {background: '#4e4e4e'}; }
  }
};
</script>

<style scoped>
.progress-bar-container {
  width: 100%;
}
.progress-bar-background {
  width: 100%;
  height: 25px;
  background-color: #7c7c7c;
  border-radius: 7px;
  overflow: hidden;
  position: relative;
}
.progress-bar-fill {
  height: 100%;
}
.progress-bar-text {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-weight: bold;
  font-size: 12px;
  pointer-events: none;
  width: 100%;
  text-align: center;
}
</style>